import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";

import { onAuthStateChanged } from "firebase/auth";

import {
  addDoc,
  collection,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";

import { auth, db } from "../firebase";

import binanceIcon from "../assets/binance.png";
import jazzcashIcon from "../assets/jazzcash.png";

function Deposit() {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("binance");
  const [txid, setTxid] = useState("");
  const [depositHistory, setDepositHistory] = useState([]);
  const [user, setUser] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const binanceAddress = "0x4fcab84a2d69d88fd81edd17b93e09114c02f1b1";
const jazzcashTillId = "983890498";

  const pkrAmount = Number(amount || 0) * 280;

  useEffect(() => {
    let unsubscribeDeposits = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);

      if (unsubscribeDeposits) {
        unsubscribeDeposits();
        unsubscribeDeposits = null;
      }

      if (!currentUser) {
        setDepositHistory([]);
        return;
      }

      const depositQuery = query(
        collection(db, "deposits"),
       where("uid", "==", currentUser.uid)
      );

      unsubscribeDeposits = onSnapshot(
        depositQuery,
        (snapshot) => {
          const history = snapshot.docs.map((depositDoc) => {
            const data = depositDoc.data();

            return {
              id: depositDoc.id,
              ...data,
              date:
                data.date ||
                (data.createdAt?.toDate
                  ? data.createdAt
                      .toDate()
                      .toLocaleDateString("en-GB")
                  : "No Date"),
            };
          });

          history.sort((a, b) => {
            const firstTime = a.createdAt?.toMillis
              ? a.createdAt.toMillis()
              : Number(a.createdAtMillis || 0);

            const secondTime = b.createdAt?.toMillis
              ? b.createdAt.toMillis()
              : Number(b.createdAtMillis || 0);

            return secondTime - firstTime;
          });

          setDepositHistory(history);
        },
        (error) => {
          console.error("Deposit history error:", error);
          setDepositHistory([]);
        }
      );
    });

    return () => {
      unsubscribeAuth();

      if (unsubscribeDeposits) {
        unsubscribeDeposits();
      }
    };
  }, []);

  const copyText = async () => {
    const textToCopy =
      method === "binance" ? binanceAddress : jazzcashTillId;

    try {
      await navigator.clipboard.writeText(textToCopy);
      alert("Copied Successfully!");
    } catch (error) {
      console.error("Copy error:", error);
      alert("Copy failed. Please copy manually.");
    }
  };

  const submitDeposit = async () => {
    if (submitting) {
      return;
    }

    const numericAmount = Number(amount);
    

    const hasPendingDeposit = depositHistory.some(
      (item) =>
        String(item.status || "").toLowerCase() === "pending"
    );

    if (hasPendingDeposit) {
      alert(
        "Your deposit request is already pending. Please wait for admin approval."
      );
      return;
    }

    if (!Number.isFinite(numericAmount) || numericAmount < 5) {
      alert("Minimum deposit amount is $5.");
      return;
    }

    if (!txid.trim()) {
      alert("Please enter Transaction ID.");
      return;
    }

    if (!user) {
      alert("Please login again.");
      return;
    }

    setSubmitting(true);

    try {
      const currentDate = new Date();

      await addDoc(collection(db, "deposits"), {
        userId: user.uid,
        uid: user.uid,
        userEmail: user.email || "",

        method:
          method === "binance"
            ? "Binance USDT BEP20"
            : "JazzCash",

        network:
          method === "binance"
            ? "BEP20"
            : "PKR Wallet",

        amount: numericAmount,
        txid: txid.trim(),
        status: "Pending",

        date: currentDate.toLocaleDateString("en-GB"),
        createdAt: serverTimestamp(),
        createdAtMillis: Date.now(),
      });

      alert(
        `Deposit request submitted!\n\nMethod: ${
          method === "binance"
            ? "Binance USDT"
            : "JazzCash"
        }\n\nAmount: $${numericAmount.toFixed(
          2
        )}\n\nTXID: ${txid.trim()}`
      );

      setAmount("");
      setTxid("");
    } catch (error) {
      console.error("Deposit save error:", error);

      alert(
        "Deposit request save nahi hui. Dobara try karein."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app deposit-page">
      <header className="page-header">
        <Link to="/dashboard" className="back-button">
          ←
        </Link>

        <div>
          <h1>Deposit</h1>
          <p>Add funds to your account</p>
        </div>
      </header>

      <section className="deposit-card">
        <h2>Select Payment Method</h2>

        <div className="payment-methods">
          <button
            type="button"
            className={`payment-method ${
              method === "binance"
                ? "active-method"
                : ""
            }`}
            onClick={() => setMethod("binance")}
          >
            <img
              src={binanceIcon}
              alt="Binance"
              className="payment-logo"
            />

            Binance USDT
            <small>BEP20</small>
          </button>

          <button
            type="button"
            className={`payment-method ${
              method === "jazzcash"
                ? "active-method"
                : ""
            }`}
            onClick={() => setMethod("jazzcash")}
          >
            <img
              src={jazzcashIcon}
              alt="JazzCash"
              className="payment-logo"
            />

            JazzCash
            <small>Till ID</small>
          </button>
        </div>
      </section>

      {method === "binance" ? (
        <section className="deposit-card">
          <div className="deposit-label-row">
            <span>USDT BEP20 Address</span>

            <span className="network-badge">
              BEP20
            </span>
          </div>

          <div className="address-box">
            <span>{binanceAddress}</span>

            <button
              type="button"
              onClick={copyText}
            >
              Copy
            </button>
          </div>

          <p className="deposit-warning">
            Only send USDT through the BEP20 network.
          </p>
        </section>
      ) : (
        <section className="deposit-card">
          <div className="deposit-label-row">
            <span>JazzCash Till ID</span>

            <span className="network-badge">
              PKR
            </span>
          </div>

          <div className="address-box">
            <span>{jazzcashTillId}</span>

            <button
              type="button"
              onClick={copyText}
            >
              Copy
            </button>
          </div>

          <p className="deposit-warning">
            Send payment to this JazzCash Till ID and
            enter the transaction ID below.
          </p>
        </section>
      )}

      <section className="deposit-card">
        <label htmlFor="depositAmount">
          Deposit Amount
        </label>

        <div className="input-wrapper">
          <span>$</span>

          <input
            id="depositAmount"
            type="number"
            min="5"
            step="0.01"
            placeholder="Enter amount"
            value={amount}
            onChange={(event) =>
              setAmount(event.target.value)
            }
          />

          <strong>USDT</strong>
        </div>

        <div className="conversion-box">
          <span>PKR Conversion</span>

          <div>
            <strong>1 USDT = 280 PKR</strong>

            <b>
              {pkrAmount.toLocaleString()} PKR
            </b>
          </div>
        </div>

        <label htmlFor="transactionId">
          Transaction ID
        </label>

        <input
          id="transactionId"
          className="deposit-input"
          type="text"
          placeholder="Enter TXID"
          value={txid}
          onChange={(event) =>
            setTxid(event.target.value)
          }
        />

        <button
          type="button"
          className="submit-deposit-button"
          onClick={submitDeposit}
          disabled={submitting}
        >
          {submitting
            ? "Submitting..."
            : "Submit Deposit"}
        </button>

        <p className="minimum-text">
          Minimum deposit: $5
        </p>
      </section>

      {depositHistory.length > 0 && (
        <section className="premium-history-section deposit-history-section last-history">
          <h2 className="history-title">
            <span className="history-title-icon">
              ▧
            </span>

            Recent Deposit History
          </h2>

          <div className="history-list">
            {depositHistory.map((item) => {
              const status = String(
                item.status || "Pending"
              );

              const normalizedStatus =
                status.toLowerCase();

              return (
                <div
                  className="premium-history-card deposit-history-card"
                  key={item.id}
                >
                  <div className="history-method-row">
                    <div className="history-method-left">
                      <div className="history-method-icon">
                        {String(item.method || "")
                          .toLowerCase()
                          .includes("jazz")
                          ? "J"
                          : "₮"}
                      </div>

                      <div className="history-method-information">
                        <strong className="history-method-name">
                          {item.method || "Deposit"}
                        </strong>

                        <span className="history-network">
                          {item.network || ""}
                        </span>
                      </div>
                    </div>

                    <span className="history-amount">
                      $
                      {Number(
                        item.amount || 0
                      ).toFixed(2)}
                    </span>
                  </div>

                  <div className="history-detail-row">
                    <span className="history-detail-label">
                      <span className="detail-icon">
                        ⟳
                      </span>

                      Status
                    </span>

                    <span
                      className={`history-status ${
                        normalizedStatus ===
                        "approved"
                          ? "status-approved"
                          : normalizedStatus ===
                            "rejected"
                          ? "status-rejected"
                          : "status-pending"
                      }`}
                    >
                      {status}
                    </span>
                  </div>

                  <div className="history-detail-row history-date-row">
                    <span className="history-detail-label">
                      <span className="detail-icon">
                        ▦
                      </span>

                      Date
                    </span>

                    <span className="history-date">
                      <span className="calendar-icon">
                        ▦
                      </span>

                      {item.date ||
                        (item.createdAt?.toDate
                          ? item.createdAt
                              .toDate()
                              .toLocaleDateString(
                                "en-GB"
                              )
                          : "No Date")}
                    </span>
                  </div>

                  <div className="history-detail-row">
                    <span className="history-detail-label">
                      TXID
                    </span>

                    <span className="history-date">
                      {item.txid || "No TXID"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}

      <nav className="bottom-nav">
        <Link
          to="/dashboard"
          className="nav-item"
        >
          <span className="nav-icon">🏠</span>
          <span>Dashboard</span>
        </Link>

        <Link
          to="/deposit"
          className="nav-item active"
        >
          <span className="nav-icon">💰</span>
          <span>Deposit</span>
        </Link>

        <Link
          to="/machine"
          className="nav-item"
        >
          <span className="nav-icon">▶️</span>
          <span>Machine</span>
        </Link>

        <Link
          to="/refer"
          className="nav-item"
        >
          <span className="nav-icon">👥</span>
          <span>Referral</span>
        </Link>

        <Link
          to="/profile"
          className="nav-item"
        >
          <span className="nav-icon">👤</span>
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
}

export default Deposit;